import type { FormattedLocation } from "@/hooks/useLocationSearch";

/**
 * Picks the string a form saves for an address answer: Google's full address (with
 * postal code and unit) once place details resolve, else the selected suggestion text.
 *
 * @param selected - Values selected in the address dropdown (at most one for forms).
 * @param locations - Locations `LocationAutocomplete` reports alongside the selection.
 * @returns The address to save, or an empty string when the field was cleared.
 */
export function pickAddressAnswer(selected: string[], locations: FormattedLocation[]): string {
  return locations[0]?.full_address || selected[0] || "";
}

/**
 * Wraps a saved address answer as a location so the dropdown can show it. The saved
 * full address never matches a fresh suggestion, so without this the field looks empty.
 *
 * @param value - The saved address answer.
 * @returns A one-item list for a non-empty answer, else an empty list.
 */
export function savedAddressLocations(value: string): FormattedLocation[] {
  if (!value) return [];

  return [
    {
      city: "",
      state: null,
      country: null,
      formatted_address: value,
      place_id: "",
      coordinates: { lat: 0, lng: 0 },
      type: "address",
    },
  ];
}
